import { store } from "./state.js";
import { geocode } from "./lib/geocoder.js";

class ReactiveRadioGroup extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("input", this);
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      // update from state
      let prop = this.getAttribute("property");
      if (prop && store.data[prop]) {
        let value = store.data[prop];
        let input = this.querySelector(`input[value="${value}"]`);
        if (input) input.checked = true;
      }
    });
  }

  handleEvent(e) {
    let prop = this.getAttribute("property");
    store.data[prop] = e.target.value;
  }
}

window.customElements.define("reactive-radiogroup", ReactiveRadioGroup);

class ReactiveSwitch extends HTMLElement {
  constructor() {
    super();
    store.addEventListener("update", this);
    this.handleEvent();
  }

  handleEvent(e = {}) {
    let { current = {} } = e;
    let prop = this.getAttribute("switch");
    let value = current[prop];
    for (let child of this.children) {
      child.toggleAttribute("hidden", child.getAttribute("case") != value);
    }
  }
}

window.customElements.define("reactive-switch", ReactiveSwitch);

class ReactiveGeocoder extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this);
    this.addEventListener("keypress", this);
  }

  gps() {
    return new Promise((ok, fail) => {
      console.log("GPS");
      navigator.geolocation.getCurrentPosition(function(gps) {
        ok([gps.coords.latitude, gps.coords.longitude]);
      }, function(error) {
        console.log(error);
        fail(error);
      });
    });
  }

  async handleEvent(e) {
    let statusBlock = this.querySelector(".status");
    switch (e.target.dataset.action) {
      case "gps":
        try {
          statusBlock.removeAttribute("hidden");
          statusBlock.innerHTML = window.STRINGS.locationStatusWorking;
          let coords = await this.gps();
          // for testing
          // coords = [41.745365, -87.692614];
          store.data.userLocation = coords;
          statusBlock.toggleAttribute("hidden", true);
        } catch (err) {
          statusBlock.innerHTML = window.STRINGS.locationStatusError;
        }
      break;

      case "typing":
        if (e.key != "Enter") return;
        // fall through on Enter

      case "address":
        try {
          statusBlock.removeAttribute("hidden");
          statusBlock.innerHTML = window.STRINGS.locationStatusWorking;
          let address = this.querySelector("input").value.trim();
          if (address.length == 0) {
            return;
          }
          let response = await geocode({
            street: address,
            city: "Chicago",
            state: "IL"
          });
          store.data.userLocation = [response.coordinates.y, response.coordinates.x];
          statusBlock.toggleAttribute("hidden", true);
        } catch (err) {
          statusBlock.innerHTML = window.STRINGS.locationStatusError;
        }
      break;
    }
  }
}

window.customElements.define("reactive-geocoder", ReactiveGeocoder);

class ReactiveSelect extends HTMLElement {
  constructor() {
    super();
    store.addEventListener("update", this);
    this.addEventListener("input", this);
  }

  handleEvent(e) {
    let select = this.querySelector("select");
    let property = this.getAttribute("property");
    let populateFrom = this.getAttribute("populatefrom");
    let template = this.querySelector("template");
    switch (e.type) {
      case "update":
        if (populateFrom) {
          let data = e.current[populateFrom] || [];
          select.toggleAttribute("hidden", data?.length == 0);
          let options = [];
          if (template) {
            let intro = [...document.importNode(template.content, true).children];
            options.push(...intro.map(e => e.cloneNode(true)));
          }
          options.push(...data.map(d => {
            let existing = this.querySelector(`option[value="${d.value}"]`);
            if (existing) return existing;
            let option = document.createElement("option");
            option.value = d.value;
            option.innerHTML = d.label;
            return option;
          }));
          select.replaceChildren(...options);
        }
        let value = e.current[property];
        select.value = value || "";
      break;

      case "input":
        store.data[property] = select.value || "";
      break;

    }
  }
}

window.customElements.define("reactive-select", ReactiveSelect);

class ReactiveShow extends HTMLElement {
  constructor() {
    super();
    store.addEventListener("update", this);
  }

  handleEvent(e) {
    let property = this.getAttribute("property");
    this.toggleAttribute("hidden", !store.raw[property]);
  }
}

window.customElements.define("reactive-show", ReactiveShow);